'use client';

import CreateAccountFields from './create-account-fields/create-account-fields';
import SignInFields from './sign-in-fields/sign-in-fields';

function AccountStepFields({ control, signInForm, register }) {
  const Fields = signInForm ? SignInFields : CreateAccountFields;

  return (
    <div>
      <Fields control={control} register={register} />
    </div>
  );
}

export default AccountStepFields;
